import {atom} from 'recoil';

export const lastMsgState = atom({
  key: 'lastMsgState',
  default: {},
});
